import { action, observable } from "mobx";
import { Subject } from "rxjs";
import { url } from "./APIEndPoints";
import HttpService from "./HttpService"; 
import {
  AuthService,
  buildParamString,
  IAPIResponse,
  ToastService,
} from "@mindmemobile/mm-shared-global";
import { BenefitsModel } from "../models/BenefitsModel";
import { IAPIBenefitsModels } from "../interfaces/IAPIBenefitsModel";

export default class ItemBenefitsService {
  @observable public benefits: BenefitsModel[] = [];
  private httpService: HttpService;
  constructor() {
    this.httpService = new HttpService(
      undefined,
      `${process.env.REACT_APP_API_KEY}`,
      process.env.REACT_APP_API_BASE_URL
    );

    AuthService.hasAccount && this.loadBenefits(AuthService.authData.accountId);
  }

  @action
  loadBenefits(accountId: string) {
    const params: string = buildParamString({
      accountId: accountId,
    });

    this.httpService
      .get<IAPIResponse<IAPIBenefitsModels[]>>(url.getAllBenefits, params)
      .subscribe({
        next: (d) => {
          this.benefits = BenefitsModel.deserializeAPIList(d.result);
        },
      });
  }

  @action
  addBenefit(
    benefit: IAPIBenefitsModels,
    subject: Subject<BenefitsModel | undefined>
  ) {
    this.httpService
      .post<IAPIResponse<IAPIBenefitsModels>>(url.createBenefit, benefit)
      .subscribe({
        next: (d) => {
          const mappedData = BenefitsModel.deserializeAPIModel(d.result);

          const ifExists = this.benefits.find((b) => b.id === mappedData.id);
          if (mappedData && !ifExists) {
            this.benefits.push(mappedData);
          }
          subject.next(mappedData);
        },
        error: (e) => {
          ToastService.showError("Error in creating benefit");
          subject.error(e);
        },
      });
  }
}
